<template>
  <div class="">
    <div class="border-bottom pb-2 mb-4">
      <h4 class="text-dark font-weight-bold mb-1">Head Office Dashboard</h4>
      <p class="text-secondary small mb-0">Overall Institution Statistics</p>
    </div>

    <!-- Primary Statistics -->
    <b-row class="mb-4">
      <b-col cols="12" sm="6" lg="3" class="mb-3">
        <b-card class="h-100">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h3 class="mb-1">{{ stats.todaysCollection }}</h3>
              <div class="text-secondary small">Today's Collection</div>
            </div>
            <b-avatar variant="success">
              <feather-icon icon="TrendingUpIcon" />
            </b-avatar>
          </div>
          <div class="mt-2 small">
            <span class="text-success">37</span> receipts today
          </div>
        </b-card>
      </b-col>

      <b-col cols="12" sm="6" lg="3" class="mb-3">
        <b-card class="h-100">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h3 class="mb-1">{{ stats.totalStudents }}</h3>
              <div class="text-secondary small">Total Students</div>
            </div>
            <b-avatar variant="primary">
              <feather-icon icon="UsersIcon" />
            </b-avatar>
          </div>
          <div class="mt-2 small">
            <span class="text-success">+{{ stats.newAdmissions }}</span> new
            admissions this month
          </div>
        </b-card>
      </b-col>

      <b-col cols="12" sm="6" lg="3" class="mb-3">
        <b-card class="h-100">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h3 class="mb-1">{{ stats.totalStaff }}</h3>
              <div class="text-secondary small">Total Staff</div>
            </div>
            <b-avatar variant="info">
              <feather-icon icon="UserCheckIcon" />
            </b-avatar>
          </div>
          <div class="mt-2 small">
            <span class="text-success">{{ stats.staffAttendance }}%</span>
            attendance today
          </div>
        </b-card>
      </b-col>

      <b-col cols="12" sm="6" lg="3" class="mb-3">
        <b-card class="h-100">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h3 class="mb-1">{{ stats.totalDues }}</h3>
              <div class="text-secondary small">Total Dues</div>
            </div>
            <b-avatar variant="warning">
              <feather-icon icon="AlertCircleIcon" />
            </b-avatar>
          </div>
          <div class="mt-2 small text-danger">
            +{{ stats.duesIncrease }} from last month
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Fee Collection Stats -->
    <b-row>
      <b-col cols="12">
        <b-card>
          <div class="d-flex justify-content-between align-items-center mb-4">
            <h5 class="mb-0">Fee Collection Overview</h5>
          </div>

          <!-- Campus-wise Breakdown -->
          <b-table
            :items="campusCollections"
            :fields="campusFields"
            striped
            hover
            responsive
            class="border-0"
          >
            <template #cell(collected)="data">
              <span class="text-success font-weight-bold">{{
                data.item.collected
              }}</span>
            </template>
            <template #cell(remaining)="data">
              <span class="text-danger font-weight-bold">{{
                data.item.remaining
              }}</span>
            </template>
            <template #cell(receipts)="data">
              <span class="font-weight-bold">{{ data.item.receipts }}</span>
            </template>
            <template #cell(actions)="data">
              <b-button
                variant="primary"
                size="sm"
                @click="printReport(data.item)"
              >
                <feather-icon icon="FileTextIcon" class="mr-50" />
                Print
              </b-button>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BBadge,
  BTable,
  BAvatar,
  BCard,
  BButton,
} from "bootstrap-vue";

export default {
  components: {
    BRow,
    BCol,
    BBadge,
    BTable,
    BAvatar,
    BCard,
    BButton,
  },
  data() {
    return {
      stats: {
        todaysCollection: 478000,
        totalStudents: 17754,
        newAdmissions: 124,
        totalStaff: 1352,
        staffAttendance: 92,
        totalDues: 2450000,
        duesIncrease: 125000,
      },
      quickStats: {
        monthlyTarget: 1500000,
        collected: 978000,
        remaining: 522000,
      },
      campusFields: [
        { key: "campus", label: "Campus" },
        { key: "collected", label: "Collected" },
        { key: "remaining", label: "Remaining" },
        { key: "receipts", label: "Receipts Generated" },
        { key: "actions", label: "Actions" },
      ],
      campusCollections: [
        {
          campus: "Main Campus",
          collected: 450000,
          remaining: 50000,
          receipts: 156,
        },
        {
          campus: "North Branch",
          collected: 280000,
          remaining: 20000,
          receipts: 98,
        },
        {
          campus: "South Branch",
          collected: 248000,
          remaining: 152000,
          receipts: 87,
        },
        {
          campus: "East Branch",
          collected: 300000,
          remaining: 0,
          receipts: 104,
        },
      ],
    };
  },
  methods: {
    printReport(item) {
      // Handle print report for specific campus
      console.log("Printing report for:", item.campus);
    },
  },
};
</script>

<style scoped></style>
